module.exports = __webpack_public_path__ + "static/media/mbti-assessment.5813732a.png";